import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { useRef, useState } from 'react';
import View from '../view';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useUID } from 'react-uid';
var AKTabs = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/tabs').then(function (module) {
    return {
      default: module.default
    };
  });
});
var AKTab = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/tabs').then(function (module) {
    return {
      default: module.Tab
    };
  });
});
var AKTabList = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/tabs').then(function (module) {
    return {
      default: module.TabList
    };
  });
});
var AKTabPanel = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/tabs').then(function (module) {
    return {
      default: module.TabPanel
    };
  });
});

// Tabs must be stateful so we don't reset to the first tab on re-renders
var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  var id = useRef(useUID());
  return jsx(AKTabs, {
    selected: selectedIndex,
    onChange: setSelectedIndex,
    id: id.current,
    shouldUnmountTabPanelOnChange: true
  }, jsx(AKTabList, null, tabs.map(function (tab, index) {
    return jsx(AKTab, {
      key: index
    }, tab.label);
  })), tabs.map(function (tab, index) {
    return jsx(AKTabPanel, {
      key: index
    }, tab.content);
  }));
};
export default Tabs;
export var TabsFn = function TabsFn(_ref2) {
  var children = _ref2.children,
    dispatch = _ref2.dispatch,
    Components = _ref2.Components,
    render = _ref2.render,
    renderChildren = _ref2.renderChildren;
  var tabData = children.map(function (child) {
    var props = child.props,
      type = child.type;
    if (type === 'Tab') {
      return {
        label: props === null || props === void 0 ? void 0 : props.label,
        content: jsx(View, {
          nonVisibleChildren: null
        }, renderChildren({
          children: child.children,
          dispatch: dispatch,
          Components: Components,
          render: render
        }))
      };
    }
  }).filter(function (child) {
    return child != null;
  });
  return jsx(Tabs, {
    tabs: tabData
  });
};